// extracted by mini-css-extract-plugin
export default {"noMessage":"MessageList_noMessage__rkrR7"};